/**
 * Returns a stable key for a File based on identity (name, size, lastModified).
 * Useful for React keys and query keys when File objects are not serializable.
 */
export const getFileKey = (file: File | undefined | null): string =>
  file ? `${file.name}-${file.size}-${file.lastModified}` : 'none';
